export default __webpack_public_path__ + "9809e88295cfb53d432564b0ea8fdfba.png";